import { createSlice } from '@reduxjs/toolkit';
import { Ticket } from '../constants/Types';

export type SelectedTicketState = {
  ticket: Ticket | undefined,
};

const initialState: SelectedTicketState = { ticket: undefined };

const selectedTicketSlice = createSlice({
  name: 'selectedTicket',
  initialState,
  reducers: {
    updateSelectedTicket(state, action: { payload: Ticket }) {
      state.ticket = action.payload;
    },
  },
});

export const { updateSelectedTicket } = selectedTicketSlice.actions;

export default selectedTicketSlice.reducer;
